import { Table, Button } from "react-bootstrap";
import {BsFillXCircleFill, BsPencilSquare} from 'react-icons/bs';
import { Link } from "react-router-dom";

export default function MaoTable({
    columnas = [], datos = [], 
    striped=true,
    totales = {},
    colId, colNombre, colEstado, 
    tituloPrimary=true,
    valueEstadoInactivo='I',
    getEstado = (estado) => {return estado===valueEstadoInactivo?'Inactivo':'Activo'},
    getClassNameFromEstado = (estado) => {return estado===valueEstadoInactivo?'table-secondary':''},
    borrar, editar, otrasAcciones, tituloAcciones='Acciones'}) {

    const cantColumnas = columnas.length + 1;

    return (
        <Table striped={striped} bordered hover responsive variant="dark" size="sm">
            <thead>
                <tr key="titulos" className={tituloPrimary?'table-primary':''}>
                    {columnas.map((c) => <th key={c.titulo} className={c.className} >{c.titulo}</th>)}
                    {editar || borrar || otrasAcciones?<th key="acciones">{tituloAcciones}</th>:<></>}
                </tr>
            </thead>
            <tbody>
                {datos.length>0 ? 
                    datos.map((d) => <tr key={d[colId]} className={getClassNameFromEstado(d[colEstado])}>
                            {columnas.map(
                                (c) => <td key={c.atributo} className={c.className}>
                                    {c.atributo===colEstado?
                                        getEstado(c.funcion?c.funcion(d[c.atributo]):d[c.atributo]):
                                        (
                                            c.atributo===colNombre?
                                            <Link onClick={(e) => {e.preventDefault();editar(d[colId]);}}>{c.funcion?c.funcion(d[c.atributo]):d[c.atributo]}</Link>:
                                            c.funcion?c.funcion(d[c.atributo]):d[c.atributo]
                                        )
                                        }
                                </td>
                            )}
                            {editar || borrar || otrasAcciones?
                                <td key="acciones" className="acciones">
                                    {editar?
                                    <Button size="sm" title="Modificar" onClick={() => editar(d[colId])}>
                                        <BsPencilSquare/>
                                    </Button>:<></>}
                                    {borrar?
                                    <Button size="sm" title="Borrar" onClick={() => borrar(d[colId])}>
                                        <BsFillXCircleFill/>
                                    </Button>:<></>}
                                    {otrasAcciones && otrasAcciones.map(acc => 
                                            {return acc.control?
                                                <>
                                                    {acc.control(d)}
                                                </>
                                            :
                                                <Button size="sm" title={acc.title} onClick={() => {acc.click(d[acc.colId] || d[colId])}}>
                                                    {acc.icon}
                                                </Button>
                                            }
                                        )}
                                </td>
                                :<></>}
                        </tr>) :
                        <tr key="sindatos">
                            <td colSpan={cantColumnas}>Sin datos</td>
                        </tr>
                }
            </tbody>
            {Object.keys(totales).length > 0?
                <tfoot>
                    <tr>
                    {columnas.map(
                                (c) => <th key={c.atributo} className={c.className}>
                                    {totales[c.atributo]}
                                </th>
                    )}
                    {editar || borrar || otrasAcciones?<th></th>:<></>}
                    </tr>
                </tfoot>
                :<></>
            }
        </Table>
    )
}